import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { ZoomInNotifier } from './zoom-in-notifier';
import { ZoomInState } from './zoom-in-state';

@Injectable()
export class ZoomInProvider extends BaseProvider<ZoomInNotifier, ZoomInState> {
  constructor() {
    super(ZoomInNotifier);
  }
}
